import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./config/reactQuery";
import { loadStripe } from "@stripe/stripe-js";
import { CssBaseline } from "@mui/material";
import { CustomThemeProvider } from "./config/ThemeProvider";

loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY || "");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <CustomThemeProvider>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </CustomThemeProvider>
  </React.StrictMode>
);
